module.exports = __webpack_public_path__ + "static/img/mycenterheadpicture.fedff2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mycenterheadpicture.png
// module id = zOWx
// module chunks = 1